import Often from 'assets/livenicons/often.svg';
import Question from 'assets/livenicons/question.svg';
import Rarely from 'assets/livenicons/rarely.svg';
import LowEnergy from 'assets/livenicons/low_energy.svg';
import Worry from 'assets/livenicons/worry.svg';
import EmotionalExhaustion from 'assets/livenicons/emotional_exhaustion.svg';
import Overthinking from 'assets/livenicons/overthinking.svg';
import Irritability from 'assets/livenicons/irritability.svg';
import TotalyFine from 'assets/livenicons/totaly_fine.svg';
import Phone from 'assets/livenicons/phone.svg';
import Coffee from 'assets/livenicons/coffee.svg';
import Shower from 'assets/livenicons/shower.svg';
import Other from 'assets/livenicons/other.svg';
import Hours1 from 'assets/livenicons/0_2_hours.svg';
import Hours2 from 'assets/livenicons/3_5_hours.svg';
import Hours3 from 'assets/livenicons/6_8_hours.svg';
import Hours4 from 'assets/livenicons/more_8_hours.svg';
import Late from 'assets/livenicons/late.svg';
import SelfDoubt from 'assets/livenicons/self_doubt.svg';
import Sugar from 'assets/livenicons/sugar.svg';
import LosingSleep from 'assets/livenicons/losing_sleep.svg';
import NailBiting from 'assets/livenicons/nail_biting.svg';
import BingeWatching from 'assets/livenicons/binge_watching.svg';
import WakingTired from 'assets/livenicons/waking_tired.svg';
import Moon from 'assets/livenicons/moon.svg';
import SleepQuality from 'assets/livenicons/sleep_quality.svg';
import Asleep from 'assets/livenicons/asleep.svg';
import Alarm from 'assets/livenicons/alarm.svg';
import SleepWell from 'assets/livenicons/sleep_well.svg';
import Family from 'assets/livenicons/family.svg';
import Circumstances from 'assets/livenicons/circumstances.svg';
import Appearance from 'assets/livenicons/appearance.svg';
import JobStress from 'assets/livenicons/job_stress.svg';
import SleepIssue from 'assets/livenicons/sleep_issue.svg';
import Calm from 'assets/livenicons/calm.svg';
import FocusLevel from 'assets/livenicons/focus_level.svg';
import Willpower from 'assets/livenicons/willpover.svg';
import EnergyLevel from 'assets/livenicons/energy_level.svg';
import InnerStrength from 'assets/livenicons/inner_strenght.svg';
import TrustOthers from 'assets/livenicons/trust_others.svg';
import Calendar from 'assets/livenicons/calendar.svg';
import Book from 'assets/livenicons/book.svg';
import Minutes1 from 'assets/livenicons/5_min.svg';
import Minutes2 from 'assets/livenicons/10_min.svg';
import Minutes3 from 'assets/livenicons/15_min.svg';
import Minutes4 from 'assets/livenicons/20_min.svg';
import Rocket from 'assets/livenicons/rocket.svg';
import Comments from 'assets/livenicons/comments.svg';
import Wellbeing from 'assets/livenicons/wellbeing.svg';
import Money from 'assets/livenicons/money.svg';
import Face from 'assets/livenicons/face.svg';
import BadHabits from 'assets/livenicons/bad_habits.svg';
import Relationships from 'assets/livenicons/relationships.svg';
import Goal from 'assets/livenicons/goal.svg';
import Worry_v2 from 'assets/livenicons/worry_v2.svg';
import Alcohol from 'assets/livenicons/alcohol.svg';

export const OptionIconsMap: Record<string, string> = {
  often: Often,
  sometimes: Question,
  rarely: Rarely,
  low_energy: LowEnergy,
  worry: Worry,
  emotional_exhaustion: EmotionalExhaustion,
  overthinking: Overthinking,
  irritability: Irritability,
  totaly_fine: TotalyFine,
  phone: Phone,
  coffee: Coffee,
  shower: Shower,
  other: Other,
  '0_2_hours': Hours1,
  '3_5_hours': Hours2,
  '6_8_hours': Hours3,
  more_than_8_hours: Hours4,
  late: Late,
  self_doubt: SelfDoubt,
  sugar: Sugar,
  losing_sleep: LosingSleep,
  nail_biting: NailBiting,
  binge_watching: BingeWatching,
  waking_tired: WakingTired,
  moon: Moon,
  sleep_quality: SleepQuality,
  difficulty_asleep: Asleep,
  alarm: Alarm,
  sleep_well: SleepWell,
  family: Family,
  circumstances: Circumstances,
  appearance: Appearance,
  job_stress: JobStress,
  sleep_issue: SleepIssue,
  calm: Calm,
  focus_level: FocusLevel,
  willpower: Willpower,
  energy_level: EnergyLevel,
  inner_strenght: InnerStrength,
  trust_others: TrustOthers,
  calendar: Calendar,
  book: Book,
  '5_min': Minutes1,
  '10_min': Minutes2,
  '15_min': Minutes3,
  '20_min': Minutes4,
  rocket: Rocket,
  comments: Comments,
  wellbeing: Wellbeing,
  money: Money,
  face: Face,
  bad_habits: BadHabits,
  relationships: Relationships,
  goal: Goal,
  worry_v2: Worry_v2,
  alcohol: Alcohol,
};
